import { interactionGroups } from "@react-three/rapier";

export const COLLISION_CATEGORIES = {
  PLAYER: 0x00000001,
  FOOD: 0x00000002,
  FURNITURE: 0x00000004,
  FLOOR: 0x00000008,
} as const;
export const COLLISION_PRESETS = {
  PLAYER: interactionGroups(COLLISION_CATEGORIES.PLAYER, [
    COLLISION_CATEGORIES.PLAYER,
    COLLISION_CATEGORIES.FOOD,
    COLLISION_CATEGORIES.FURNITURE,
    COLLISION_CATEGORIES.FLOOR,
  ]),
  PLAYERISHOLD: interactionGroups(COLLISION_CATEGORIES.PLAYER, [
    COLLISION_CATEGORIES.PLAYER,
    COLLISION_CATEGORIES.FURNITURE,
    COLLISION_CATEGORIES.FLOOR,
  ]),
  FOODHIDE: interactionGroups(COLLISION_CATEGORIES.FOOD, [
    COLLISION_CATEGORIES.FOOD,
    COLLISION_CATEGORIES.FLOOR,
    COLLISION_CATEGORIES.FURNITURE,
  ]), // 食物只与地面碰撞（用于隐形食物）
  FOOD: interactionGroups(COLLISION_CATEGORIES.FOOD, [
    // COLLISION_CATEGORIES.FOOD,
    COLLISION_CATEGORIES.PLAYER,
    COLLISION_CATEGORIES.FURNITURE,
    COLLISION_CATEGORIES.FLOOR,
  ]),
  FURNITURE: interactionGroups(COLLISION_CATEGORIES.FURNITURE, [
    COLLISION_CATEGORIES.PLAYER,
    COLLISION_CATEGORIES.FOOD,
    COLLISION_CATEGORIES.FLOOR,
  ]),
  FLOOR: interactionGroups(
    COLLISION_CATEGORIES.FLOOR, // membership
    [
      COLLISION_CATEGORIES.PLAYER,
      COLLISION_CATEGORIES.FOOD,
      COLLISION_CATEGORIES.FURNITURE,
    ],
  ),
} as const;
